import { createSelector } from '@reduxjs/toolkit';

import { MENTEE_LESSON_STATUSES } from 'data/menteeLessonStatuses';
import { SUPER_BATCH_TYPES } from 'data/superBatchTypes';
import { UPDATE_ACTIONS } from '@classCreation/data/updateActions';

const baseSelector = (state) => state.editCrashCourseBatch;

export const editCrashCourseBatchSelector = (state) => baseSelector(state);

export const selectedSuperBatchSelector = (state) =>
  baseSelector(state).selectedSuperBatch;

export const learnerUpdateActionSelector = (state) =>
  baseSelector(state).learnerUpdateAction;

export const pastClassesStatusSelector = (state) =>
  baseSelector(state).pastClassesStatus;

export const upcomingClassesStatusSelector = createSelector(
  (state) => baseSelector(state).learnerUpdateAction,
  (state) => baseSelector(state).selectedSuperBatch,
  (learnerUpdateAction, selectedSuperBatch) => {
    if (
      learnerUpdateAction === UPDATE_ACTIONS.add &&
      selectedSuperBatch.batch_type === SUPER_BATCH_TYPES.crashCourse
    ) {
      return MENTEE_LESSON_STATUSES.crashCourse;
    }

    if (
      learnerUpdateAction === UPDATE_ACTIONS.add &&
      selectedSuperBatch.batch_type === SUPER_BATCH_TYPES.secondary
    ) {
      return MENTEE_LESSON_STATUSES.active;
    }

    if (learnerUpdateAction === UPDATE_ACTIONS.remove) {
      return MENTEE_LESSON_STATUSES.inactive;
    }
  }
);

export const learnerEmailsSelector = (state) =>
  baseSelector(state).learnerEmails;

export const editCrashCourseBatchModalStateSelector = (state) =>
  baseSelector(state).modalState;

export const batchSequenceSelector = (state) =>
  baseSelector(state).batchSequence;

export const moduleRepeatSelector = (state) => baseSelector(state).moduleRepeat;
